exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-653390a0] .el-input-number--small{width:280px!important}", ""]);

// exports
